import RootState from 'model/State/RootState';

export const selectLocations = (state: RootState) => state.locations;
